// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3scol","rootNoMargin":"styles_rootNoMargin__2VnWl"};